import { useEffect, useState } from 'react';
import { FFBType } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

export type BenefitType = {
  id: string;
  displayName: string;
  sortField: string;
  isSelectable: boolean;
  shortName?: string;
}

export type TargetGroupType = {
  id: string;
  displayName: string;
  isSelectable: boolean;
  sortField: string;
  shortName?: string;
}

export type OfferType = {
  id: string;
  displayName: string;
}

const grantClient = moduleClientFactory.createCitizenGrantClient(true);

export function useGetBenefitTypes() {
  const [benefitTypes, setBenefits] = useState<BenefitType[]>([]);
  const [targetGroupTypes, setTargetGroups] = useState<TargetGroupType[]>([]);
  const [offerTypes, setOffers] = useState<OfferType[]>([]);

  useEffect(() => {
    async function loadBenefitTypes() {
      const benefitTypesResponse = await grantClient.getBenefitTypes();

      const ffbBenefits = benefitTypesResponse.benefitTypesFfb?.filter(x => x.type === FFBType.Benefit) ?? [];
      const dstBenefits = benefitTypesResponse.benefitTypesDst ?? [];

      const mappedBenefitTypes: BenefitType[] = [
        ...ffbBenefits.map(x => ({
          id: x.id,
          displayName: x.name ?? '',
          sortField: x.name ?? '',
          isSelectable: x.isSelectable ?? true,
          shortName: x.shortName,
        })),
        ...dstBenefits.map(x => ({
          id: x.id,
          displayName: x.name ?? '',
          sortField: x.name ?? '',
          isSelectable: true,
          shortName: undefined,
        })),
      ];

      const allTargetGroups = benefitTypesResponse.benefitTypesFfb?.filter(x => x.type === FFBType.TargetGroup) ?? [];
      const mappedTargetGroups: TargetGroupType[] = allTargetGroups.map(x => ({
        id: x.id,
        displayName: x.name ?? '',
        sortField: x.name ?? '',
        isSelectable: x.isSelectable,
        shortName: x.shortName,
      }));

      const allOffers = benefitTypesResponse.benefitTypesFfb?.filter(x => x.type === FFBType.Offer) ?? [];
      const mappedOffers: OfferType[] = allOffers.map(x => ({
        id: x.id,
        displayName: x.name ?? '',
      }));

      setBenefits(mappedBenefitTypes);
      setTargetGroups(mappedTargetGroups);
      setOffers(mappedOffers);
    }
    loadBenefitTypes();
  }, []);

  return { benefitTypes, targetGroupTypes, offerTypes };
}
